import * as React from 'react'
import { AccountService } from './accountService'
import { ProductsListService } from './productsListService'
import { ArticleService } from './articleService'

export const AccountServiceContext = React.createContext(null as any as AccountService)
export const ProductsListServiceContext = React.createContext(null as any as ProductsListService)
export const ArticleServiceContext = React.createContext(null as any as ArticleService)
